import { ajaxSend } from 'api/api';
export function getAllLanguages(payload) {
    const request = {
        path: `/v1/flows/${payload.flowID}/languages`,
    };
    return ajaxSend(request);
}
